import About from "../pages/about/About";
import Contact from "../pages/contact/ContactComponent";
import Education from "../pages/education/EducationComponent";
import Error404 from "../pages/errors/error404/Error";
import Experience from "../pages/experience/Experience";
import Home from "../pages/home/HomeComponent";
import Opensource from "../pages/opensource/Opensource";
import Projects from "../pages/projects/Projects";
import Services from "../pages/services/index";
import Splash from "../pages/splash/Splash";
import { settings } from "../portfolio";
import React, { Component } from "react";
import { Route, Switch, BrowserRouter } from "react-router-dom";


export default class Main extends Component {
  render() {
    return (
      <BrowserRouter basename="/">
        <Switch>
          <Route
            path="/"
            exact
            render={(props) =>
              settings.isSplash ? (
                <Splash {...props} theme={this.props.theme} />
              ) : (
                <Home {...props} theme={this.props.theme} />
              )
            }
          />
          <Route
            path="/home"
            render={(props) => <Home {...props} theme={this.props.theme} />}
          />
          <Route
            path="/about"
            exact
            render={(props) => (
              <About {...props} theme={this.props.theme} />
            )}
          />
          <Route
            path="/services"
            exact
            render={(props) => (
              <Services {...props} theme={this.props.theme} />
            )}
          />
          <Route
            path="/experience"
            exact
            render={(props) => (
              <Experience {...props} theme={this.props.theme} />
            )}
          />
          <Route
            path="/education"
            render={(props) => (
              <Education {...props} theme={this.props.theme} />
            )}
          />
          <Route
            path="/opensource"
            render={(props) => (
              <Opensource {...props} theme={this.props.theme} />
            )}
          />
          <Route
            path="/contact"
            render={(props) => <Contact {...props} theme={this.props.theme} />}
          />

          {settings.isSplash && (
            <Route
              path="/splash"
              render={(props) => <Splash {...props} theme={this.props.theme} />}
            />
          )}

          <Route
            path="/projects"
            render={(props) => <Projects {...props} theme={this.props.theme} />}
          />
          <Route
            path="*"
            render={(props) => <Error404 {...props} theme={this.props.theme} />}
          />
        </Switch>
      </BrowserRouter>
    );
  }
}
